export const CONTACT = {
  phone: "07393018095",
  phoneHref: "tel:07393018095",
  snapchat: "fstlnedetailing",
  snapchatHref: "https://www.snapchat.com/add/fstlnedetailing",
  tiktok: "fastlanedetailing1ltd",
  tiktokHref: "https://www.tiktok.com/@fastlanedetailing1ltd",
};

export const CORE_SERVICES = [
  { icon: "Sparkles", title: "Car Detailing", desc: "Deep interior & exterior detailing for a showroom finish." },
  { icon: "Car", title: "Full Valets", desc: "Complete inside-out valet, wheels, glass and trim." },
  { icon: "Disc3", title: "Polishing & Buffing", desc: "Swirl & scratch correction with a deep glossy shine." },
  { icon: "Waves", title: "Driveway Cleaning", desc: "Pressure washing to lift dirt, moss and stubborn grime." },
  { icon: "Home", title: "Gutter Cleaning", desc: "Safe, thorough gutter clearing for homes and units." },
  { icon: "Truck", title: "Fleet & Commercial", desc: "Reliable contracts for vans, fleets and businesses." },
];

export const SPECIALIST = [
  {
    icon: "SunMedium",
    title: "Window Tints",
    tag: "From £30",
    desc: "Precision-cut tints for style, privacy and heat reduction across all vehicle types.",
    points: ["Sun strips & full sets", "Hatchback · Saloon · SUV · Van", "Professional bubble-free fit"],
  },
  {
    icon: "ShieldCheck",
    title: "PPF Paint Protection",
    tag: "Panels & Full Body",
    desc: "Self-healing paint protection film that keeps your paintwork flawless for years.",
    points: ["Individual panels & kits", "Essential · Full Front · Track packs", "Full-vehicle wraps available"],
  },
  {
    icon: "Cctv",
    title: "Dash Cam Supply & Fit",
    tag: "From £99",
    desc: "Professional hardwired dash cam installs with hidden cabling and parking mode.",
    points: ["Front / Front & Rear · 2K · 4K", "Lifetime installation warranty", "Cars, vans & fleet vehicles"],
  },
];

export const WHY = [
  { n: "01", title: "Professional finish", desc: "Every vehicle is treated with care, precision and pride — inside and out." },
  { n: "02", title: "Prices you can trust", desc: "Premium results without the premium price tag. Honest, upfront quotes." },
  { n: "03", title: "Fleet & commercial", desc: "Dependable contracts and mobile service for businesses of every size." },
  { n: "04", title: "Local & reliable", desc: "A trusted local team that turns up, delivers, and stands behind the work." },
];

export const PRICE_PREVIEW = [
  { label: "Front sun strip", price: "£30" },
  { label: "5-door hatchback tint", price: "£100" },
  { label: "Standard headlight tint (pair)", price: "£70" },
  { label: "PPF — front bumper", price: "£300" },
  { label: "PPF Essential Package", price: "£850" },
  { label: "Basic front dash cam", price: "from £99" },
];

export const WINDOW_TINTS = [
  ["Front sun strip", "£30"],
  ["3-door hatchback (rear windows)", "£70"],
  ["5-door hatchback", "£100"],
  ["Saloon", "£100"],
  ["Estate", "£100"],
  ["SUV / 4x4", "£120"],
  ["Small van", "£100"],
  ["Medium van", "£100"],
];

export const HEADLIGHT_TINTS = [
  ["Standard headlight tint (pair)", "£70"],
  ["Premium gloss / PPF tint (pair)", "£100"],
  ["Chameleon or coloured tint (pair)", "£120"],
  ["Fog lights", "£20–£30"],
  ["Headlights + rear lights package", "£140–£170"],
];

export const PPF_PANELS = [
  ["Door cups (4)", "£40"],
  ["Door edges (4)", "£50"],
  ["Wing mirrors", "£60"],
  ["Headlights", "£120"],
  ["Front bumper", "£300"],
  ["Bonnet", "£325"],
  ["Front wings (pair)", "£375"],
  ["Boot loading strip", "£100"],
  ["Side skirts", "£250"],
];

export const PPF_PACKAGES = [
  { title: "Essential Package", price: "£850", desc: "Bumper, partial bonnet, partial wings, headlights." },
  { title: "Full Front End", price: "£1,250", desc: "Full bonnet, full bumper, full wings, mirrors, headlights." },
  { title: "Track Pack", price: "£1,500", desc: "Full front + side skirts + A-pillars + roof edge." },
];

export const FULL_PPF = [
  ["Hatchback", "from £1,750"],
  ["Saloon", "from £2,000"],
  ["Estate", "from £2,200"],
  ["SUV / 4x4", "from £2,500"],
  ["Supercars", "from £3,000"],
];

export const DASH_CAMS = [
  ["Basic Front Dash Cam", "from £99"],
  ["Basic Front & Rear Dash Cam", "from £149"],
  ["2K Front & Rear Dash Cam", "from £199"],
  ["4K Front & Rear Dash Cam", "from £249"],
  ["Premium Dash Cam with Parking Mode", "from £349"],
];

export const DASH_POINTS = [
  "Lifetime Installation Warranty",
  "Hidden Cable Installation",
  "Mobile Service Available",
  "Hardwire Kits Available",
  "Cars, Vans & Fleet Vehicles",
  "Professional hardwired installation",
];
